import { Joi, objectSchemaOf } from '../helpers';

export interface ICreateVisitorParams {
  organisationId: string;
  firstName: string;
  lastName?: string;
}

export const createVisitorParamsSchema = objectSchemaOf<ICreateVisitorParams>({
  organisationId: Joi.string().required(),
  firstName: Joi.string().required(),
  lastName: Joi.string(),
});

export interface IDeleteVisitorParams {
  visitorId: string;
}

export const deleteVisitorParamsSchema = objectSchemaOf<IDeleteVisitorParams>({
  visitorId: Joi.string().required(),
});

export interface IGetVisitorParams {
  visitorId: string;
}

export const getVisitorParamsSchema = objectSchemaOf<IGetVisitorParams>({
  visitorId: Joi.string().required(),
});

export interface IListVisitorParams {
  organisationId: string;
}

export const listVisitorParamsSchema = objectSchemaOf<IListVisitorParams>({
  organisationId: Joi.string().required(),
});

export type IUpdateVisitorParams = Partial<ICreateVisitorParams> & {
  visitorId: string;
};

export const updateVisitorParamsSchema = objectSchemaOf<IUpdateVisitorParams>({
  visitorId: Joi.string().required(),
  organisationId: Joi.string(),
  firstName: Joi.string(),
  lastName: Joi.string(),
});
